<template>
	<div>
		<el-dialog
			title=""
			:visible="$store.state.event.ticketDialog"
			@close="close"
			width="30%"
			center>
			<div v-show="Object.keys($store.state.event.ticketData).length > 0" id="print-area" class="print-area" style="font-family: 'Roboto', sans-serif;padding: 5px;margin: 0 auto;text-align: center;">
				<div class="print-area__username" style="font-size: 25px;font-weight: bold;">{{ $store.state.event.ticketData.person_info.first_name }}<br>{{ $store.state.event.ticketData.person_info.last_name }}</div>
				<barcode class="print-area__barcode" v-bind:value="$store.state.event.ticketData.id" height="20" display-value="false">
				</barcode>
				<div class="print-area__seat" style="	font-weight: bold;text-transform: uppercase;">{{ $store.state.event.ticketData.seat }}</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import VueBarcode from 'vue-barcode'
export default {
	components: {
		'barcode': VueBarcode
	},
	data () {
		return {
			ticket: {
				id: 123,
				first_name: 'Игроь',
				last_name: 'безлепкин',
				seat: '12'
			}
		}
	},
	mounted () {
	},
	methods: {
		close () {
			this.$store.commit('event/TICKET_DIALOG_HIDE')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/event/Ticket.vue